export default "__VITE_ASSET__C7tQjWGy__"